import { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import TextField from "@mui/material/TextField";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { FormProvider, useForm, Controller } from "react-hook-form";
import ApiGallery from "../../../core/api/api.gallery";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import _ from "lodash";
import { styled } from "@mui/material/styles";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import Paging from "../_Components/Paging";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/SaveRounded";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEyeRounded";
import { AddModal } from "./AddModal";
import { isMobile } from "react-device-detect";
import SelectComponent from "../_Components/ReactSelectComponent";

export const Gallery = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({ defaultValues: { pageSize: 10, pageNumber: 1 } });
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [listData, setListData] = useState([]);
  const [listOption, setListOption] = useState([]);
  const [listType, setListType] = useState([]);
  const [listSelective, setListSelective] = useState([]);
  const [showModalGallery, setShowModalGallery] = useState(false);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  const useStyles = styled((theme) => ({
    root: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      backgroundColor: theme.palette.background.paper,
    },
    ImageList: {
      width: "100%",
      height: "auto",
    },
  }));
  const classes = useStyles({});

  useEffect(() => {
    (async () => {
      try {
        const galleryOptionList = await ApiGallery.getGalleryOption();

        setListOption(galleryOptionList.data.filter(item => item.value != 3));
        const galleryTypeList = await ApiGallery.getGalleryType();

        setListType(galleryTypeList.data.filter(item => item.value != 7));

        // بعدا پاک شود جهت راحتی برای کار اورده شده
        const apiData = await ApiGallery.getAllGallery({
          pageNumber: getValues("pageNumber"),
          pageSize: getValues("pageSize"),
        });
        if (apiData.succeeded) {
          setListData(apiData.data);
          setValue("totalCount", apiData.totalCount);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const handlelistTypeChange = async (value) => {
    setValue("type", value);
    if (_.isNumber(value?.value) && value?.value > 0) {
      //لیست ایتم های وابسته به انتخاب نوع فایل
      const apiData = await ApiGallery.getSelectiveListByGalleryType({ Type: value?.value });

      if (apiData.succeeded) {
        setListSelective(apiData?.data);
        setValue("selectedId", apiData.data[0].value);
      } else {
        //SwalMessage({ title: apiData.message, iSsuccess: false });
        setListSelective([]);
        setValue("selectedId", undefined);
      }
    } else {
      setListSelective([]);
      setValue("selectedId", undefined);
    }
  };

  async function DeleteIMG(item) {
    Swal.fire({
      title: "عملیات حذف تصویر",
      text: "ایا قصد حذف این تصویر را دارید؟",
      icon: "question",
      showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      // cancelButtonText: 'انصراف',
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }

  const deleteApi = async (id) => {
    const apiData2 = await ApiGallery.deleteGallery({ id: id });
    if (apiData2.succeeded) {
      const apiData = await ApiGallery.getAllGallery({
        pageNumber: getValues("pageNumber"),
        pageSize: getValues("pageSize"),
      });
      if (apiData.succeeded) {
        setListData(apiData.data);
        setValue("totalCount", apiData.totalCount);
      }
    }
    SwalMessage({ title: apiData2.message, iSsuccess: apiData2.succeeded });
  };

  const onSubmit = async (data) => {
    data.pageNumber = getValues("pageNumber");
    data.selectedId = data.selectedId?.value;
    data.type = data.type?.value;
    data.option = data.option?.value;
    const apiData = await ApiGallery.getAllGallery(data);
    if (apiData.succeeded) {
      setListData(apiData.data);
      setValue("totalCount", apiData.totalCount);
    } else SwalMessage({ title: apiData.message, iSsuccess: false });
  };

  return (
    <div>
      {showModalGallery && <AddModal showModalGallery={showModalGallery} setShowModalGallery={setShowModalGallery} />}

      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت تصاویر</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm"> لیست تصاویر/ویدئوها</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setShowModalGallery(true);
              }}
            >
              <AddCircle className="mr-1" />
              افزودن تصویر/ویدئو
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={handleSubmit(onSubmit)}>
                <div className="border-bottom pb-5">
                  <Row>
                    <Col xs="12" sm lg className="px-2">
                      <Controller
                        name="option"
                        control={control}
                        // rules={{ required: true, }}
                        render={({ field }) => (
                          <SelectComponent
                            className="w-100 mt-2"
                            placeholder="نوع"
                            variant="outlined"
                            size="small"
                            options={listOption?.map((item) => ({
                              value: item.id,
                              label: item.title,
                            }))}
                            field={field}
                          />
                        )}
                      />
                      {/* {errors.type && <span>لطفا نوع فایل را وارد نمایید</span>} */}
                    </Col>
                    <Col xs="12" sm lg className="px-2">
                      <Controller
                        name="type"
                        control={control}
                        // rules={{ required: true, }}
                        render={({ field: { value } }) => (
                          <SelectComponent
                            className="w-100 mt-2"
                            placeholder="دسته"
                            options={listType?.map((item) => ({
                              value: item.id,
                              label: item.title,
                            }))}
                            value={value}
                            onChange={handlelistTypeChange}
                          />
                        )}
                      />
                      {/* {errors.type && <span>لطفا دسته را وارد نمایید</span>} */}
                    </Col>
                    <Col xs="12" sm lg className="px-2">
                      <Controller
                        name="selectedId"
                        control={control}
                        // rules={{ required: true, }}
                        render={({ field }) => (
                          <SelectComponent
                            className="w-100 mt-2"
                            placeholder="گروه"
                            options={listSelective?.map((item) => ({
                              value: item.id,
                              label: item.title,
                            }))}
                            field={field}
                          />
                        )}
                      />
                    </Col>
                    <Col xs="12" sm lg className="px-2">
                      <Controller
                        name="imageAlt"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="عنوان"
                            margin="normal"
                            variant="outlined"
                            className=" mt-2"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                    </Col>
                    <Col xs="12" sm="2" md="1" lg="2" xl="1" className="px-2">
                      <Button
                        className="mt-2 w-100"
                        variant="secondary"
                        type="submit"
                        disabled={isSubmitting}
                        style={{ height: "37px" }}
                      >
                        {isSubmitting ? <Spinner animation="border" variant="warning" size="sm" /> : <SearchIcon />}

                      </Button>
                    </Col>
                  </Row>
                </div>
                <Row>
                  {listData?.length > 0 ? (
                    <Col xs="12" className="mt-4">
                      <div className={classes.root}>
                        <ImageList className={classes.ImageList} cellheight={180} cols={isMobile ? 1 : 5}>
                          {listData?.map((item) => (
                            <ImageListItem key={item.id} cols={item.cols || 1}>
                              {item.option == 1 || item.option == 3
                                ? <img
                                  width="100%"
                                  height="100%"
                                  src={process.env.REACT_APP_PHOTOPATH_WEB + item.imageUrl}
                                  alt={item.imageAlt}
                                />
                                : <video
                                  width="100%"
                                  height="100%"
                                  style={{ maxHeight: 200 }}
                                  src={process.env.REACT_APP_PHOTOPATH_WEB + item.imageUrl}
                                  alt={item.imageAlt}
                                />
                              }
                              <ImageListItemBar
                                title={item.imageAlt}
                                subtitle={<span>توسط: {item.createdByFullName}</span>}
                                actionIcon={
                                  <>
                                    <IconButton
                                      className="bg-dark text-light"
                                      title="حذف"
                                      onClick={(event) => DeleteIMG(item.id)}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                    <IconButton title={item.option == 1 ? "مشاهده تصویر" : "مشاهده ویدئو"} LinkComponent="a" target="_blank" href={process.env.REACT_APP_PHOTOPATH_WEB + item.imageUrl} rel="noreferrer" className="bg-dark mx-1 text-light" title="نمایش">
                                      <RemoveRedEyeIcon />
                                    </IconButton>
                                    <IconButton
                                      className="bg-dark text-light"
                                      title="کپی آدرس"
                                      onClick={() => {
                                        navigator.clipboard.writeText(item.imageUrl);
                                      }}
                                    >
                                      <SaveIcon />
                                    </IconButton>
                                  </>
                                }
                              />
                            </ImageListItem>
                          ))}
                        </ImageList>
                      </div>
                      <Paging config={config} {...methods} />
                    </Col>
                  ) : (
                    <Col xs="12" className="py-5">
                      تصاویری برای این جستجو پیدا نشد.
                    </Col>
                  )}
                </Row>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};
